import { runbookServerConstants } from "../constants/runbookServer.constants";

export function runbookServer(state = {}, action) {
  switch (action.type) {
    case runbookServerConstants.GET_ALL_REQUEST:
    case runbookServerConstants.GET_REQUEST:
    case runbookServerConstants.GET_BY_ID_REQUEST:
    case runbookServerConstants.CREATE_REQUEST:
    case runbookServerConstants.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
        error: false,
        success: false,
      };

    case runbookServerConstants.GET_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };

    case runbookServerConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };

    case runbookServerConstants.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        server: action.payload,
      };

    case runbookServerConstants.CREATE_SUCCESS:
    case runbookServerConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case runbookServerConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
      };

    case runbookServerConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
      };

    case runbookServerConstants.GET_ALL_FAILURE:
    case runbookServerConstants.GET_FAILURE:
    case runbookServerConstants.GET_BY_ID_FAILURE:
    case runbookServerConstants.CREATE_FAILURE:
    case runbookServerConstants.UPDATE_FAILURE:
    case runbookServerConstants.DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload || "An error occurred",
      };

    case "CLEAR_ERROR":
      return {
        ...state,
        error: false,
        errorMessage: null,
      };

    default:
      return state;
  }
}
